import axios from "axios";
import { baseUrl } from "./baseUrl";

// App info API
const api = axios.create({
    baseURL: `${baseUrl}/admin/documents`,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

// list Document
export const listDocuments = async () => {
    try {
        const response = await api.get("/list-documents");
        return response.data.data;
    } catch (error) {
        console.error("Error fetching document list:", error);
        throw error;
    }
};

// Document Types API
export const createDocumentType = async (data) => {
    try {
        const response = await api.post("/create-document-type", data);
        return response.data;
    } catch (error) {
        console.error("Error creating document type:", error);
        throw error;
    }
};

export const getDocumentType = async (id) => {
    try {
        const response = await api.get(`/get-document-type/${id}`);
        return response.data.data;
    } catch (error) {
        console.error("Error fetching document type:", error);
        throw error;
    }
};

export const updateDocumentType = async ({ id, data }) => {
    try {
        const response = await api.put(`/update-document-type/${id}`, data);
        return response.data;
    } catch (error) {
        console.error("Error updating document type:", error);
        throw error;
    }
};

export const deleteDocumentType = async (id) => {
    try {
        const response = await api.delete(`/delete-document-type/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting document type:", error);
        throw error;
    }
};

export const listDocumentTypes = async () => {
    try {
        const response = await api.get("/get-document-types-list");
        return response.data.data;
    } catch (error) {
        console.error("Error fetching document types:", error);
        throw error;
    }
};

export const updateDocument = async ({ id, name, documentType }) => {
    try {
        const response = await api.put("/update-document", { id, name, documentType });
        return response.data;
    } catch (error) {
        console.error("Error updating document:", error);
        throw error;
    }
};
